<template>
  <div class="custom-select-wrapper" ref="selectWrapper">
    <div
      :id="id"
      class="custom-select-trigger form-input no-icon"
      :class="{
        'error': error,
        'is-open': isOpen,
        'disabled': disabled
      }"
      @click="toggleDropdown"
      role="button"
      tabindex="0"
      @keydown.enter.prevent="toggleDropdown"
      @keydown.space.prevent="toggleDropdown"
      @keydown.esc="closeDropdown"
    >
      <span>{{ displayLabel }}</span>
    </div>

    <div class="custom-options-menu" v-if="isOpen">
      <div
        v-if="allowEmpty"
        class="custom-option-item"
        :class="{ 'is-selected': isSelected('') }"
        @click="selectOption('', emptyLabel || placeholder)"
      >
        {{ emptyLabel || placeholder }}
      </div>

      <div
        v-for="(item, index) in formattedOptions"
        :key="index"
        class="custom-option-item"
        :class="{ 'is-selected': isSelected(item.value) }"
        @click="selectOption(item.value, item.label)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: [Array, Object],
      default: () => [],
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: 'ရွေးချယ်ပါ',
    },
    emptyLabel: {
      type: String,
      default: '',
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    formattedOptions() {
      if (!this.options) return [];

      if (Array.isArray(this.options)) {
        return this.options.map((item) => {
          if (item !== null && typeof item === 'object') {
            return {
              value: item[this.valueKey] !== undefined ? item[this.valueKey] : item.id || item.value,
              label: item[this.labelKey] !== undefined ? item[this.labelKey] : item.name || item.label || item.category_name || item.township_name,
            };
          }
          return { value: item, label: item };
        });
      }

      // If object (e.g. key-value map like regionArr: { 1: 'Yangon', 2: 'Mandalay' })
      return Object.keys(this.options).map((key) => ({
        value: key,
        label: this.options[key],
      }));
    },
    selectedOption() {
      if (this.value === '' || this.value === null || this.value === undefined) {
        return null;
      }
      return this.formattedOptions.find(
        (opt) => String(opt.value) === String(this.value)
      );
    },
    displayLabel() {
      if (this.selectedOption) {
        return this.selectedOption.label;
      }
      return this.placeholder;
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    isSelected(val) {
      if ((val === '' || val === null || val === undefined) && (this.value === '' || this.value === null || this.value === undefined)) {
        return true;
      }
      return String(this.value) === String(val);
    },
    selectOption(val, label) {
      this.$emit('input', val);
      this.$emit('change', { value: val, label: label });
      this.closeDropdown();
    },
    handleClickOutside(event) {
      if (this.$refs.selectWrapper && !this.$refs.selectWrapper.contains(event.target)) {
        this.closeDropdown();
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.custom-select-trigger.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
